import { useState } from "react";

import { Label, Radio, RadioGroup, RadioGroupOption } from "@headlessui/react";

import { useSupplierVouchers } from "../../data/useSupplierVouchers";
import Modal from "../../layouts/Modal";
import { ISupplier } from "../../models/Supplier";
import { IVoucher } from "../../models/Voucher";
import classNames from "../../utils/classNames";
import VoucherTable from "../vouchers/VoucherTable";
import { PlusSmallIcon } from "@heroicons/react/24/outline";
import VoucherModal from "../vouchers/VoucherModal";

interface SupplierVoucherModalProps {
    open: boolean,
    setOpen: React.Dispatch<React.SetStateAction<boolean>>,
    supplier?: ISupplier | null;
}

export default function SupplierVoucherModal({ open, setOpen, supplier }: SupplierVoucherModalProps) {
    const { vouchers: supplierVouchers } = useSupplierVouchers(supplier?.id ?? "");
    const [voucher, setVoucher] = useState<IVoucher | null>(null);
    const [createOpen, setCreateOpen] = useState(false);

    const handleSetVoucher = (voucher: IVoucher) => {
        setVoucher(voucher);
        setCreateOpen(true);
    }

    if (supplier == null) {
        return (
            <Modal width="max-w-3xl" open={open} setOpen={setOpen} >
                <></>
            </Modal>
        );
    }
    
    return (
        <Modal width="max-w-4xl" open={open} setOpen={setOpen} >
            <>
                
                <VoucherModal 
                    open={createOpen} 
                    setOpen={setCreateOpen} 
                    voucher={voucher ?? undefined} 
                    supplier={supplier ?? undefined} 
                />
                
            

                <h1 className="text-xl">{`${supplier.name}'s Vouchers`}</h1>
                <small className="text-gray-500"><i>
                    Manage vouchers for {supplier.name}.
                </i></small>

                <div className="mt-4 flex justify-between">
                    <button
                        className=" bg-primary-600 hover:bg-primary-700 inline-flex items-center rounded-md border border-transparent px-3 py-2 text-sm font-medium leading-4 text-white shadow-sm"
                        onClick={() => setCreateOpen(true)}
                    >
                        <PlusSmallIcon className="h-5 w-5 mr-2" />
                        Add Voucher
                    </button>
                </div>

                { supplierVouchers.isLoading ? (
                    <div className="mt-8 min-h-[50vh] my-4 p-4 bg-white rounded-lg shadow">
                        <p>Loading vouchers...</p>
                    </div>
                ) : (
                    <VoucherTable vouchers={supplierVouchers.data?.data ?? []} setVoucher={handleSetVoucher} />
                )}

            </>
        </Modal>
    )
}